import WelcomeScreen from "./WelcomeScreen.jsx";

export default WelcomeScreen;
